import { render, staticRenderFns } from "./subscription-activity-rules-form.vue?vue&type=template&id=c6c19f54&"
import script from "./subscription-activity-rules-form.vue?vue&type=script&lang=ts&"
export * from "./subscription-activity-rules-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports